import { cn } from "@humanex/ui/libs";

interface SelectableCardProps {
  isSelected?: boolean;
  isDisabled?: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
  className?: string;
}

export function SelectableCard({
  isSelected = false,
  isDisabled,
  onClick,
  children,
  className
}: SelectableCardProps) {
  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className={cn(
        "border rounded-2xl text-left transition-all duration-300 cursor-pointer",
        isSelected
          ? "border border-secondary-400 bg-secondary-50"
          : "border border-gray-200 hover:border-gray-300 hover:shadow-lg hover:-translate-y-1",
        isDisabled && "opacity-40 pointer-events-none",
        className
      )}
    >
      {children}
    </button>
  );
}
